import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

interface UpdatePayScheduleEmployeesParams {
  payScheduleId: string
  employeeIds: string[]
}

export function useUpdatePayScheduleEmployees () {
  return useMutation({
    mutationFn: async ({ payScheduleId, employeeIds }: UpdatePayScheduleEmployeesParams) => {
      const response = await fetchWithHeaders(`/api/web/employers/employees/pay_schedules/${payScheduleId}`, {
        method: 'POST',
        body: JSON.stringify({
          employee_ids: employeeIds,
          pay_schedule_id: payScheduleId,
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to update pay schedule employees')
      }

      return response.json()
    },
  })
}
